import React from "react";
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import { useNavigate } from 'react-router-dom';
import { HelmetProvider, Helmet } from "react-helmet-async"; // Use Helmet from react-helmet-async
import cssConfig from '../cssConfig';

export const SignInPage = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();

    const handleLoginPopup = () => {
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: '/redirect',
            })
            .catch((error) => console.log(error));
    };

    const handleForgotPassword = (event) => {
        event.preventDefault();
        navigate('/forgotPassword');
    };

    return (
        <HelmetProvider>
            <Helmet>
                {/* Fonts */}
                <link
                    href="//fonts.googleapis.com/css?family=Roboto:500,700"
                    rel="stylesheet"
                    type="text/css"
                />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link
                    rel="preconnect"
                    href="https://fonts.gstatic.com"
                    crossOrigin="true"
                />
                <link
                    href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap"
                    rel="stylesheet"
                />
                {/* Meta Tag */}
                <meta name="viewport" content="width=device-width, initial-scale=1" />

                <style>
                    {
                        `
                            /* Base styles */
                            body {
                                margin: 0;
                                font-family: "Inter", serif;
                                height: 100vh;
                                width: 100vw;
                                background-color: ${cssConfig.backgroundColor};
                                color: #ffffff;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }

                            #root {
                                margin: 0;
                                font-family: "Inter", serif;
                                height: 100%;
                                width: 100%;
                                background-color: ${cssConfig.backgroundColor};
                                color: #ffffff;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            }

                            html {
                                height: 100%;
                                width: 100%;
                            }

                            #api-container-blink {
                                width: 100%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                            }

                            #api-container {
                                width: 60%;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                            }

                            .footer-p {
                                margin-top: 20px;
                            }

                            /* Main Container with Image and Form */
                            .main-container-blink {
                                display: flex;
                                width: 100%;
                                max-width: 600px;
                                background-color: ${cssConfig.mainBackgroundColor};
                                border-radius: 8px;
                                box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
                                height: 514px;
                            }

                            .main-container {
                                display: flex;
                                width: 100%;
                                max-width: 1200px;
                                background-color: ${cssConfig.mainBackgroundColor};
                                border-radius: 8px;
                                box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
                                height: 514px;
                                margin: 3%;
                            }

                            /* Left Image Section */

                            .image-section-blink {
                                width: 45%
                            }

                            .image-section {
                                width: 35%;
                                background-image: url(${cssConfig.coverUrl});
                                background-size: cover;
                                background-position: center;
                                border-radius: 8px 0 0 8px;
                            }

                            /* Right Form Section */
                            .form-section {
                                width: 58%;
                                padding: 42px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                margin-left: 4%;
                            }

                            .form-section-blink {
                                width: 100%;
                                padding: 80px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                margin-left: -33%;
                            }

                            .form-section-bp {
                                width: 100%;
                                padding: 80px;
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                margin-left: -45%;
                            }

                            .entry-item label {
                                display: none;
                            }

                            .rememberMe {
                                display: none;
                            }

                            .form-section h2 {
                                font-size: 24px;
                                font-weight: bold;
                                color: ${cssConfig.textColor};
                                margin-bottom: 10px;
                            }

                            .form-section p {
                                font-size: 16px;
                                font-weight: 300;
                                color: ${cssConfig.textColor};
                                margin-bottom: 20px;
                            }

                            .form-section-blink h2 {
                                font-size: 24px;
                                font-weight: bold;
                                color: ${cssConfig.textColor};
                                margin-bottom: 10px;
                            }

                            .form-section-blink p {
                                font-size: 16px;
                                font-weight: 300;
                                color: ${cssConfig.textColor};
                                margin-bottom: 20px;
                            }

                            .form-section-bp h2 {
                                font-size: 24px;
                                font-weight: bold;
                                color: ${cssConfig.textColor};
                                margin-bottom: 10px;
                            }

                            .form-section-bp p {
                                font-size: 16px;
                                font-weight: 300;
                                color: ${cssConfig.textColor};
                                margin-bottom: 20px;
                            }

                            /* Form Styles from #api */
                            #api {
                                display: flex;
                                flex-direction: column;
                                width: 100%;    
                                background-color: ${cssConfig.mainBackgroundColor}; /* Matches modal background */
                                padding: 20px;
                                border-radius: 8px;
                                margin-bottom: 15px;
                            }

                            .entry-item input {
                                width: 65%;
                                padding: 16px;
                                padding-left: 40px; /* Space for icons */
                                margin-bottom: 10px;
                                border: 1px solid #cccccc;
                                border-radius: 8px;
                                font-size: 16px;
                                font-weight: 400;
                                background-color: #ffffff;
                                color: #000000;
                                background-repeat: no-repeat;
                                background-position: 12px center;
                                background-size: 21px;
                                font-family: "Inter", serif;
                            }

                            /* Username icon */
                            #signInName {
                                background-image: url('https://eussocontent.blob.core.windows.net/sso-custom-ui/profile.png');
                            }
                            
                            #password {
                                background-image: url('https://eussocontent.blob.core.windows.net/sso-custom-ui/threedots.png');
                            }

                            .buttons {
                                width: 160px;
                                padding-top: 10px;
                            }

                            .buttons button {
                                width: 100%;
                                padding: 15px;
                                background-color: ${cssConfig.buttonColor};
                                border: none;
                                border-radius: 8px;
                                color: ${cssConfig.buttonTextColor};
                                font-size: 16px;
                                cursor: pointer;
                                text-transform: capitalize;
                                padding-bottom: 10px;
                                padding-top: 10px;
                                line-height: 20px;
                                font-family: "Inter", serif;
                                height: 51px;
                                font-weight: 500;
                            }

                            .buttons button:hover {
                                background-color: ${cssConfig.buttonHoverColor};
                            }

                            .intro {
                                display: none;
                            }

                            /* Footer Section */
                            .footer {
                                margin-top: 0px;
                                font-size: 16px !important;
                                color: ${cssConfig.textColor};
                                font-family: "Inter", serif;
                                line-height: 24px;
                                font-weight: 300 !important;
                                text-align: left;
                                width: 100%;
                            }

                            .footer a {
                                color: ${cssConfig.hrefColor};
                                font-weight: 600;
                                text-decoration: underline;
                                background: transparent;
                                padding: 0;
                                border-radius: 0%;
                            }

                            .footer a:hover {
                                text-decoration: none;
                            }

                            /* New Text Section */
                            .text-section-blink {
                                text-align: left;
                                margin-bottom: 20px;
                                font-size: 16px;
                                font-family: "Inter", serif;
                                color: ${cssConfig.textColor};
                                width: 100%;
                                line-height: 24px;
                            }

                            .text-section {
                                text-align: left;
                                margin-bottom: 20px;
                                font-size: 16px;
                                font-family: "Inter", serif;
                                color: ${cssConfig.textColor};
                                width: 60%;
                                line-height: 24px;
                            }

                            .text-section h2 {
                                font-size: 22px;
                                font-weight: 500;
                                color: ${cssConfig.textColor};
                                line-height: 29px;
                                padding-bottom: 20px;
                                margin-top: 0px;
                                margin-bottom: 0px;
                            }

                            .text-section-blink h2 {
                                font-size: 22px;
                                font-weight: 500;
                                color: ${cssConfig.textColor};
                                line-height: 29px;
                                padding-bottom: 20px;
                                margin-top: 0px;
                                margin-bottom: 0px;
                            }

                            .forgetPasswordLink {
                                margin-bottom: 0px !important;
                            }

                            .text-section span {
                                font-family: "Inter", serif;
                                font-weight: 300;
                                font-size: 18px;
                                color: ${cssConfig.textColor};
                                margin: 0;
                                display: flex;
                                align-items: center;
                            }

                            .text-section-blink span {
                                font-family: "Inter", serif;
                                font-weight: 300;
                                font-size: 18px;
                                color: ${cssConfig.textColor};
                                margin: 0;
                                display: flex;
                                align-items: center;
                            }

                            /* Footer Branding */
                            .branding-one {
                                text-align: left;
                                font-size: 12px;
                                color: ${cssConfig.brandingColor};
                                font-family: "Inter", serif;
                                line-height: 17px;
                                position: relative;
                                top: ${cssConfig.brandingPosition};
                            }

                            /* Footer Branding */
                            .logo-one {
                                margin-bottom: 20px;
                                text-align: center;
                                position: relative;
                                top: -${cssConfig.logoTop};
                                left: ${cssConfig.logoLeft};
                            }

                            .logo-one img {
                                max-width: ${cssConfig.logoDesktopWidth};
                                height: auto;
                            }

                            /* Logo Section */
                            .logo {
                                margin-bottom: 20px;
                                text-align: center;
                                position: absolute;
                                top: 15%;
                                display: none;
                            }

                            .logo img {
                                max-width: ${cssConfig.logoDesktopWidth};
                                height: auto;
                                max-height: 43px;
                            }

                            .branding-one a {
                                color: ${cssConfig.brandingColor};
                                text-decoration: underline;
                                background: transparent;
                                padding: 0;
                                border-radius: 0%;
                            }

                            .branding-one a:hover {
                                text-decoration: none;
                            }

                            /* Footer Branding */
                            .branding {
                                text-align: left;
                                font-size: 12px;
                                color: ${cssConfig.brandingColor};
                                font-family: "Inter", serif;
                                line-height: 17px;
                                position: relative;
                                top: 101%;
                                display: none;
                            }

                            .branding a {
                                color: ${cssConfig.brandingColor};
                                text-decoration: underline;
                                background: transparent;
                                padding: 0;
                                border-radius: 0%;
                            }

                            .text-section-span {
                                font-size: 14px !important;
                                font-weight: 500 !important ;
                                color: ${cssConfig.headerTextColor} !important;
                                padding-bottom: 20px;
                            }

                            #forgotPassword {
                                display: none !important;
                            }

                            .divider {
                                display: none !important;
                            }

                            .pageLevel p {
                                font-size: 14px !important;
                                font-stretch: normal;
                                font-style: normal;
                                line-height: 1;
                                letter-spacing: normal;
                                padding: 0px;
                                color: red !important;
                            }
                            
                            /* Mobile-Specific Styles */
                            @media (max-width: 768px) {
                                body {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: unset;
                                }

                                #root {
                                    display: flex;
                                    flex-direction: column;
                                    justify-content: unset;
                                }

                                .logo {
                                    margin-bottom: 0px;
                                    text-align: center;
                                    display: block;
                                    position: initial;
                                    margin-top: 20px;
                                }

                                .footer-p {
                                    margin-top: 0px !important;
                                }

                                

                                .main-container {
                                    flex-direction: column;
                                    width: 96%;
                                    height: auto;
                                }

                                .main-container-blink {
                                    flex-direction: column;
                                    width: 96%;
                                    height: auto;
                                    margin-top: 3%;
                                    margin-bottom: 3%;
                                }

                                .branding-one {
                                    display: none;
                                }

                                .text-section {
                                    width: 94%;
                                    margin-bottom: 0px;
                                    margin-top: 3%;
                                }

                                .text-section-blink {
                                    width: 94%;
                                    margin-bottom: 0px;
                                    margin-top: 3%;
                                }

                                #api-container {
                                    width: 98%;
                                }

                                #api-container-blink {
                                    width: 98%;
                                }

                                .image-section {
                                    width: 100%;
                                    height: 130px;
                                    border-radius: 8px 8px 0 0;
                                    background-image: url(${cssConfig.coverMobileUrl});
                                }

                                .text-section h2 {
                                    padding-bottom: 10px;
                                    margin-bottom: 8px;
                                }

                                .text-section-blink h2 {
                                    padding-bottom: 10px;
                                    margin-bottom: 8px;
                                }

                                .text-section-span {
                                    padding-bottom: 10px;
                                    color: ${cssConfig.headerTextColor} !important;
                                    margin-bottom: 8px !important;
                                    font-size: 14px !important;
                                    font-weight: 500 !important ;
                                }

                                .form-section {
                                    padding: 20px;
                                    width: 90%;
                                    margin-left: 0;
                                    padding-right: 24px;
                                    padding-left: 24px;
                                }

                                .form-section-blink {
                                    padding: 20px;
                                    width: 90%;
                                    margin-left: 0;
                                    padding-right: 24px;
                                    padding-left: 24px;
                                }

                                .form-section-bp {
                                    padding: 20px;
                                    width: 90%;
                                    margin-left: 0;
                                    padding-right: 24px;
                                    padding-left: 24px;
                                }

                                .entry-item input {
                                    width: 80%;
                                }

                                .footer {
                                    margin-top: 0px;
                                }

                                .form-section p {
                                    margin-top: 0px;
                                    margin-bottom: 10px;
                                }

                                .form-section-blink p {
                                    margin-top: 0px;
                                    margin-bottom: 10px;
                                }

                                .form-section-bp p {
                                    margin-top: 0px;
                                    margin-bottom: 10px;
                                }

                                .forgetPasswordLink {
                                    margin-bottom: 10px !important;
                                }

                                .logo-one {
                                    display: none;
                                }
                                

                                .branding {
                                    text-align: left;
                                    font-size: 12px;
                                    color: ${cssConfig.brandingColor};
                                    font-family: "Inter", serif;
                                    line-height: 17px;
                                    width: 95%;
                                    margin-left: 0%;
                                    position: initial;
                                    display: block;
                                }

                                .forgetPasswordLink {
                                    margin-bottom: 20px !important;
                                }
                            }

                            @media (max-width: 400px) { 
                                .entry-item input {
                                    width: 80%;
                                }

                                #api-container {
                                    width: 96%;
                                }

                                #api-container-blink {
                                    width: 96%;
                                }
                            }

                            @media (max-width: 335px) {
                                .form-section {
                                    width: 88%;
                                }

                                .form-section-blink {
                                    width: 88%;
                                }

                                .form-section-bp {
                                    width: 88%;
                                }

                                .entry-item input {
                                    width: 80%;
                                }
                            }
                        `
                    }
                </style>
            </Helmet>
            <>
                <div className="logo">
                    <img src={cssConfig.logoMobileUrl} alt={`${cssConfig.brandName} Logo`} />
                </div>

                <div className={cssConfig.mainContainer}>
                    <div className={cssConfig.imageSection}>
                        <div className="logo-one">
                            <img src={cssConfig.logoUrl} alt={`${cssConfig.brandName} Logo`} />
                        </div>
                        <div className="branding-one">
                            {cssConfig.footerText} <br />
                            powered by <a href="https://cocentric.com/connect-frontline" target="_blank" rel="noreferrer">Connect by Cocentric</a>
                        </div>
                    </div>

                    <div className={cssConfig.formSection}>
                        <div className={cssConfig.textSection}>
                            {cssConfig.userCircleUrl !== '' && <span className="text-section-span">
                                <img src={cssConfig.userCircleUrl} style={{ paddingRight: '5px' }} alt="User Circle" />
                                {cssConfig.headerText}
                            </span>}
                            <h2>Sign in to your account</h2>
                            <p style={{ marginTop: 0, marginBottom: 0, fontSize: '16px', fontWeight: 300 }}>Log in to access your account and continue where you left off.</p>
                        </div>
                        <div id={cssConfig.apiContainer}>
                            <div id="api">
                                <div className="intro">
                                    <h2 aria-level="1">
                                    Sign in to your account
                                    </h2>
                                </div>
                                <div className="error pageLevel" aria-hidden="true" role="alert" style={{ display: 'none' }}>
                                    <p></p>
                                </div>
                                <div className="entry">
                                    <div className="buttons">
                                        <button id="next" onClick={handleLoginPopup}>Sign in</button>
                                    </div>
                                </div>
                            </div>
                            <div className="footer">
                                <p className="forgetPasswordLink"><span style={{ fontWeight: 600 }}>Forgot password?</span> <a className="forgetPassword" href="#" onClick={handleForgotPassword}>Reset your password</a>.</p>
                            </div>
                            <div className="footer">
                                <p className="footer-p">
                                    If you need support, please speak to your line manager or the People Team.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="branding">
                    {cssConfig.footerText} <br/>
                    powered by <a href="https://cocentric.com/connect-frontline" target="_blank" rel="noreferrer">Connect by Cocentric</a>
                </div>
            </>
        </HelmetProvider>
    );
}
